var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCirclePlay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.25,
    height: 16.25,
    viewBox: "0 0 16.25 16.25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_ionic-md-play-circle",
    "data-name": "Icon ionic-md-play-circle",
    d: "M10,1.875A8.125,8.125,0,1,0,18.125,10,8.129,8.129,0,0,0,10,1.875ZM8.375,13.656V6.344L13.25,10Z",
    transform: "translate(-1.875 -1.875)",
    fill: "#185cff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCirclePlay);
export default __webpack_public_path__ + "static/media/circle-play.26d3c53b335763b89568834b023ef08c.svg";
export { ForwardRef as ReactComponent };